var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "share-whatsapp_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469",
    stopOpacity: 0.219
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "share-whatsapp_svg__b",
    x1: ".108%",
    x2: "99.892%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "share-whatsapp_svg__c",
    x1: "0%",
    x2: "100%",
    y1: "93.559%",
    y2: "6.441%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "url(#share-whatsapp_svg__a)",
    rx: 21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#share-whatsapp_svg__b)",
    d: "M0 19.418l1.358-4.825A9.657 9.657 0 01.025 9.686C.025 4.346 4.37 0 9.711 0s9.686 4.345 9.686 9.686-4.345 9.686-9.686 9.686a9.67 9.67 0 01-4.735-1.235L0 19.418zm5.23-3.043l.297.181a8.015 8.015 0 004.184 1.173c4.435 0 8.043-3.608 8.043-8.043 0-4.435-3.608-8.043-8.043-8.043-4.435 0-8.043 3.608-8.043 8.043 0 1.545.44 3.046 1.27 4.34l.2.31-.783 2.78 2.875-.74z",
    transform: "translate(11 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#share-whatsapp_svg__c)",
    d: "M6.99 5.178l-.628-.034a.76.76 0 00-.54.184c-.305.265-.793.777-.942 1.443-.223.994.122 2.211 1.014 3.428.893 1.218 2.556 3.165 5.497 3.997.948.268 1.694.087 2.269-.281.456-.292.77-.76.883-1.288l.1-.469a.326.326 0 00-.182-.364l-2.124-.979a.327.327 0 00-.394.097l-.834 1.081a.238.238 0 01-.268.08c-.571-.2-2.484-1.002-3.534-3.024a.243.243 0 01.03-.269l.797-.922a.323.323 0 00.053-.34l-.915-2.143a.326.326 0 00-.282-.197z",
    transform: "translate(11 11)"
  }))));
}
export default SvgShareWhatsapp;